// extracted by mini-css-extract-plugin
export default {"zoomControls":"B--z","zoomControlButton":"C--z","zoomBanner":"D--z","bannerButton":"E--z","imageButton":"F--z","zoom":"G--z","zoomContent":"H--z"};